import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=37dd5616&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=37dd5616&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=37dd5616&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd5616",
  null
  
)

export default component.exports